import { NgClass, NgIf, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PaletteType } from '@cf/core';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-text-truncate',
  templateUrl: './text-truncate.component.html',
  styleUrls: ['./text-truncate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgClass, SlicePipe, NgxTolgeeModule],
})
export class TextTruncateComponent {
  @Input({ required: true }) text!: string;

  @Input() count = 50;

  @Input() entityName = '';

  @Input() color: PaletteType = 'blue-50';

  showMore = false;
}
